import React, { useCallback, useState } from 'react';
import { node } from 'prop-types';
import dayjs from 'dayjs';

import {
  postAutoOrder,
  editAutoOrder,
  delMfAutoOrder,
} from '@screens/MutualFundDetail/MfDeposit/fetcher';
import localeId from 'dayjs/locale/id';

dayjs.locale(localeId);

export const MfContext = React.createContext();

const MfProvider = ({ children }) => {
  const monthOptions = [3, 6, 9, 12];
  const dayJSminDate = dayjs().add(1, 'day');
  const minimumDate = {
    year: dayjs(dayJSminDate).year(),
    month: dayjs(dayJSminDate).month() + 1,
    day: dayjs(dayJSminDate).date(),
  };

  const [isMfAutoOrder, setIsMfAutoOrder] = useState(false);
  const [monthsAutoOrder, setMonthsAutoOrder] = useState(monthOptions[1]);
  const [selectedDay, setSelectedDay] = useState(minimumDate);
  const [ammountMfAutoOrder, setAmmountMfAutoOrder] = useState();

  const _normalDateFormat = `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`;
  const selectedDayFormat = dayjs(_normalDateFormat).format('DD MMMM YYYY');
  const nextRunMF = dayjs(_normalDateFormat).format('YYYY-MM-DD');
  const endOfSelectedDay = dayjs(_normalDateFormat)
    .add(monthsAutoOrder - 1, 'month')
    .format('DD MMMM YYYY');

  const isEndOfMonth = selectedDay.day > 28;

  const handleToggleSwitch = () => {
    setSelectedDay(minimumDate);
    setIsMfAutoOrder(!isMfAutoOrder);
  };

  const requestMfAutoOrder = useCallback((payload) => postAutoOrder(payload), [postAutoOrder]);
  const deleteMfAutoOrder = useCallback((payload) => delMfAutoOrder(payload), [delMfAutoOrder]);
  const changeMfAutoOrder = useCallback((payload) => editAutoOrder(payload), [editAutoOrder]);

  const valueProps = {
    isMfAutoOrder,
    isEndOfMonth,
    changeMfAutoOrder,
    requestMfAutoOrder,
    setIsMfAutoOrder,
    handleToggleSwitch,
    monthsAutoOrder,
    monthOptions,
    minimumDate,
    selectedDay,
    setSelectedDay,
    setMonthsAutoOrder,
    selectedDayFormat,
    endOfSelectedDay,
    deleteMfAutoOrder,
    ammountMfAutoOrder,
    setAmmountMfAutoOrder,
    nextRunMF,
  };

  return <MfContext.Provider value={valueProps}>{children}</MfContext.Provider>;
};

MfProvider.propTypes = {
  children: node.isRequired,
};

export default MfProvider;
